import {
    faBook,
    faCalendarDays,
    faDumbbell,
    faEuro,
    faHandshake,
    faHomeLg,
    faImages,
    faListCheck,
    faNewspaper,
    faQuestionCircle,
    faTimes,
    faTrophy,
    faUser,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ReactNode, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { useMenu } from '../../../context/MenuContext'
import { useClickOutside } from '../../../hooks/useClickOutside'
import { useLangSelected } from '../../../hooks/useLangSelected'
import AdminContainer from '../../admin/AdminContainer'
import { CloseButton, SideBar, SidebarLink } from './MemberSideBar'
interface SidebarProps {
    children: ReactNode
    isOpen?: boolean
}

export const AdminSideBar = ({ children, isOpen = false }: SidebarProps) => {
    const { closeMenu } = useMenu()
    const sidebarRef = useRef<HTMLDivElement>(null)

    useClickOutside(sidebarRef, closeMenu)
    const location = useLocation()

    let lng = useLangSelected()

    const { t } = useTranslation()

    return (
        <>
            <SideBar ref={sidebarRef} isOpen={isOpen}>
                <CloseButton onClick={closeMenu}>
                    <FontAwesomeIcon style={{ width: '30px', height: '30px' }} icon={faTimes} />
                </CloseButton>
                <SidebarLink
                    to={`/${lng}/bva-admin`}
                    className={location.pathname === `/${lng}/bva-admin` ? 'active' : ''}
                >
                    <FontAwesomeIcon icon={faHomeLg} /> {t('sidebar.admin.dashboard')}
                </SidebarLink>
                <SidebarLink
                    to={`/${lng}/bva-admin/utilisateurs`}
                    className={location.pathname.includes(`/${lng}/bva-admin/utilisateurs`) ? 'active' : ''}
                >
                    <FontAwesomeIcon icon={faUser} /> {t('sidebar.admin.user')}
                </SidebarLink>
                <SidebarLink
                    to={`/${lng}/bva-admin/articles`}
                    className={location.pathname.includes(`/${lng}/bva-admin/articles`) ? 'active' : ''}
                >
                    <FontAwesomeIcon icon={faNewspaper} /> {t('sidebar.admin.news')}
                </SidebarLink>
                <SidebarLink
                    to={`/${lng}/bva-admin/partenaires`}
                    className={location.pathname.includes(`/${lng}/bva-admin/partenaires`) ? 'active' : ''}
                >
                    <FontAwesomeIcon icon={faHandshake} /> {t('sidebar.admin.partners')}
                </SidebarLink>
                <SidebarLink
                    to={`/${lng}/bva-admin/tournois-badnet`}
                    className={location.pathname.includes(`/${lng}/bva-admin/tournois-badnet`) ? 'active' : ''}
                >
                    <FontAwesomeIcon icon={faTrophy} /> {t('sidebar.admin.badnet')}
                </SidebarLink>
                <SidebarLink
                    to={`/${lng}/bva-admin/plannings`}
                    className={location.pathname.includes(`/${lng}/bva-admin/plannings`) ? 'active' : ''}
                >
                    <FontAwesomeIcon icon={faCalendarDays} /> {t('sidebar.admin.plannings')}
                </SidebarLink>
                <SidebarLink
                    to={`/${lng}/bva-admin/tarifs`}
                    className={location.pathname.includes(`/${lng}/bva-admin/tarifs`) ? 'active' : ''}
                >
                    <FontAwesomeIcon icon={faEuro} /> {t('sidebar.admin.prices')}
                </SidebarLink>
                <SidebarLink
                    to={`/${lng}/bva-admin/documentation`}
                    className={location.pathname.includes(`/${lng}/bva-admin/documentation`) ? 'active' : ''}
                >
                    <FontAwesomeIcon icon={faBook} /> {t('sidebar.admin.documentation')}
                </SidebarLink>
                <SidebarLink
                    to={`/${lng}/bva-admin/me-documenter`}
                    className={location.pathname.includes(`/${lng}/bva-admin/me-documenter`) ? 'active' : ''}
                >
                    <FontAwesomeIcon icon={faBook} /> {t('sidebar.admin.to-document-myself')}
                </SidebarLink>
                <SidebarLink
                    to={`/${lng}/bva-admin/coachs`}
                    className={location.pathname.includes(`/${lng}/bva-admin/coachs`) ? 'active' : ''}
                >
                    <FontAwesomeIcon icon={faDumbbell} /> {t('sidebar.admin.coachs')}
                </SidebarLink>
                <SidebarLink
                    to={`/${lng}/bva-admin/faq`}
                    className={location.pathname.includes(`/${lng}/bva-admin/faq`) ? 'active' : ''}
                >
                    <FontAwesomeIcon icon={faQuestionCircle} /> {t('sidebar.admin.faq')}
                </SidebarLink>
                <SidebarLink
                    to={`/${lng}/bva-admin/carousel`}
                    className={location.pathname.includes(`/${lng}/bva-admin/carousel`) ? 'active' : ''}
                >
                    <FontAwesomeIcon icon={faImages} /> {t('sidebar.admin.carousel')}
                </SidebarLink>
                <SidebarLink
                    to={`/${lng}/bva-admin/shop/produits`}
                    className={location.pathname.includes(`/${lng}/bva-admin/shop/produits`) ? 'active' : ''}
                >
                    🛒 {t('shop.title')}
                </SidebarLink>
                <SidebarLink
                    to={`/${lng}/bva-admin/shop/commandes`}
                    className={location.pathname.includes(`/${lng}/bva-admin/shop/commandes`) ? 'active' : ''}
                >
                    <FontAwesomeIcon icon={faNewspaper} /> {t('shop.admin.manageOrders')}
                </SidebarLink>
                <SidebarLink
                    to={`/${lng}/bva-admin/shop/scanner`}
                    className={location.pathname.includes(`/${lng}/bva-admin/shop/scanner`) ? 'active' : ''}
                >
                    📱 {t('shop.admin.scannerLink')}
                </SidebarLink>
                <SidebarLink
                    to={`/${lng}/bva-admin/badnet-queue`}
                    className={location.pathname.includes(`/${lng}/bva-admin/badnet-queue`) ? 'active' : ''}
                >
                    <FontAwesomeIcon icon={faListCheck} /> {t('admin.badnet.queue.title')}
                </SidebarLink>

                {/* <SidebarLink
                                to={`/${lng}/bva-admin/bva-bot`}
                                className={location.pathname.includes(`/${lng}/bva-admin/bva-bot`) ? 'active' : ''}
                            >
                                <FontAwesomeIcon icon={faRobot} />
                                {t('sidebar.admin.bva-bot')}
                            </SidebarLink> */}
            </SideBar>
            <AdminContainer>{children}</AdminContainer>
        </>
    )
}

export default AdminSideBar
